import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import Button from "../../common/Button";
import { useMutation } from "@tanstack/react-query";
import { resendOtp } from "@/services/authService";
import { toast } from "react-toastify";
import { ConfirmNumberProps } from "@/types/authType";

function ConfirmNumber({
  otp,
  setOtp,
  onSubmit,
  isLoading,
  mobileNumber,
  reset,
  setStep,
}: ConfirmNumberProps) {
  //  State  //
  const [timeLeft, setTimeLeft] = useState(120);
  const [isTimerRunning, setIsTimerRunning] = useState(true);
  //  Api Hook  //
  const { mutateAsync: mutateResendOtp } = useMutation({
    mutationFn: resendOtp,
    retry: 2,
    retryDelay: 1000,
  });

  //  Effect  //
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isTimerRunning && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    } else if (timeLeft === 0) {
      setIsTimerRunning(false);
    }

    return () => clearInterval(interval);
  }, [isTimerRunning, timeLeft]);

  //  Constant  //
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  //  Function  //
  const handleResendCode = async () => {
    setTimeLeft(120);
    setIsTimerRunning(true);
    try {
      const data = await mutateResendOtp({ mobileNumber });
      if (data?.success) {
        toast.success(`${data?.message} ${data?.confirmCode}`);
      } else {
        toast.error(data?.message);
      }
    } catch (err) {
      console.log("error in resending otp code", err);
    }
  };
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (otp.length === 5) {
      onSubmit(e);
    }
  };
  return (
    <form onSubmit={handleSubmit} className="w-full mt-5 flex flex-col gap-3">
      <div className="flex flex-col">
        <p className="mt-8 text-ws-gray-800  text-base num-vazir">
          کد تأیید ارسال شده به شماره {mobileNumber} را وارد کنید.
        </p>

        <OTPInput
          value={otp}
          onChange={(value) => setOtp(value)}
          numInputs={5}
          inputType="tel"
          containerStyle="otp-class"
          inputStyle="otp-input text-lg mt-5 bg-ws-shark-50 border-0"
          shouldAutoFocus={true}
          renderInput={(props) => <input {...props} />}
        />
      </div>
      <div className="flex justify-between  px-1">
        <div className="flex justify-start items-center flex-col">
          <div
            className={` items-center gap-1 ${timeLeft ? "flex" : "hidden"}`}
          >
            <span
              className={`block w-11 text-sm  num-vazir ${
                timeLeft < 30 && timeLeft !== 120
                  ? "text-red-500"
                  : "text-ws-gray-700"
              } `}
            >
              0{minutes}:{seconds < 10 ? `۰${seconds}` : seconds}
            </span>
          </div>
          {timeLeft === 0 ? (
            <p
              onClick={handleResendCode}
              className="cursor-pointer bg-ws-light-blue inline-block py-1 px-3  text-ws-gray-500 text-xs font-bold rounded-lg bg-blue-50"
            >
              {"ارسال مجدد کد"}
            </p>
          ) : null}
        </div>
      </div>

      <Button
        variant="dark-gray"
        type="submit"
        className="h-14 w-full mt-2 rounded-xl"
        isLoading={isLoading}
        isValid={otp.length == 5 ? true : false}
      >
        <span className="text-sm">{"تایید"}</span>
      </Button>
      <p
        onClick={() => {
          setOtp("");
          setStep(1);
          reset();
        }}
        className="underline underline-offset-[6px]	 cursor-pointer font-medium text-base text-center text-ws-gray-500 mt-5"
      >
        {"تغییر شماره موبایل"}
      </p>
    </form>
  );
}

export default ConfirmNumber;
